// -----------------------------------------------------------------------------
// KI-Anbieter
// -----------------------------------------------------------------------------

import * as generalUtility from '../utility/generalUtility';

window.Mustache = Mustache; // eslint-disable-line no-undef

const init = () => {
  if ($('.js-body').hasClass('js-body-ki-anbieter') === false) {
    return;
  }

  initEventListeners();
  initSearch();
};

const initEventListeners = () => {
  // Scrolling Effect navbar fur ki
  $(window).on('scroll', function () {
    var offset = $('.ki__header').next().offset().top;
    var nav = $('#header').height();
    if ($(window).scrollTop() >= (offset - nav)) {
      $('header .aws-navbar, header #header').attr('style', 'background-color: #00377a !important');
      $('header .btn-login').fadeIn();
    } else {
      $('header .aws-navbar, header #header').attr('style', 'background-color: transparent !important');
      $('header .btn-login').fadeOut();
    }
  });
};

/**
 * KI-Anbietersuche einrichten
 */
const initSearch = () => {
  const q = decodeUrlParameter(getUrlParameter('q'));
  const branche = getUrlParameter('branche');
  const usecase = getUrlParameter('usecase');
  const standort = getUrlParameter('standort');
  const $searchInput = $('#search-input');

  if (q) $searchInput.val(q);
  if (branche) $(`.branchen[value="${branche}"]`).prop('checked', true);
  if (usecase) $(`.usecases[value="${usecase}"]`).prop('checked', true);
  if (standort) $(`.standorte[value="${standort}"]`).prop('checked', true);

  reFilter();

  $('.KIanbieter input').change(function () {
    reFilter();
  });

  $searchInput.keyup(function () {
    if ($(this).val().length >= 3 || $(this).val().length === 0) {
      reFilter();
    }
  });

  Mustache.Formatters = { // eslint-disable-line no-undef
    date: function (str) {
      if (str) {
        const dt = new Date(str.substr(0, 10));
        return (dt.getDate() + '.' + (dt.getMonth() + 1) + '.' + dt.getFullYear());
      }
      return null;
    }
  };
};

/**
 * Gibt URL-Parameter zurück
 *
 * @param sParam
 * @returns {*}
 */
const getUrlParameter = (sParam) => {
  const sPageURL = window.location.search.substring(1);
  const sURLVariables = sPageURL.split('&');

  for (let i = 0; i < sURLVariables.length; i++) {
    let sParameterName = sURLVariables[i].split('=');

    if (sParameterName[0] === sParam) {
      return (typeof sParameterName[1] === 'undefined') ? true : decodeURIComponent(sParameterName[1]);
    }
  }

  return '';
};

/**
 * Leerzeichen in URL-Parameter entfernen
 *
 * @param str
 * @returns {*}
 */
const decodeUrlParameter = (str) => {
  if (typeof str === 'undefined') {
    return '';
  }
  return decodeURIComponent((str + '').replace(/\+/g, '%20'));
};

/**
 * Liste abhängig von Filtereinstellungen neu laden
 *
 * @param loadmore
 */
const reFilter = (loadmore = false) => {
  const basepath = $('.js-body').attr('data-basepath');
  const search = $('.KIanbieter :input').serialize();
  const trans = generalUtility.getJsonFromHtml('.js-body-ki-anbieter #trans');

  $.ajax({
    method: 'POST',
    url: `${basepath}/api/getKIAnbieter`,
    data: {
      q: search,
      loadmore: loadmore
    }
  })
    .done(function (data) {
      const dataParsed = JSON.parse(data);
      let html = '';

      $('.js-count').html(dataParsed.count);
      if (dataParsed.anbieter.length > 0) {
        html = Mustache.to_html($('#templateData').html(), dataParsed); // eslint-disable-line no-undef
      } else {
        html = `<h2>${trans.es_konnten_keine_suchergebnisse_gefunden_werden}</h2>`;
      }
      $('#DataResults').html(html);
    });
};

export {
  init
};
